
    <canvas #imageContainer [width]="width" [height]="height"
      (tap)="onTap($event)" (pinchin)="processTouchEvent($event)" (pinchout)="processTouchEvent($event)"
      (panmove)="processTouchEvent($event)" (panend)="onTouchEnd()" (rotatemove)="processTouchEvent($event)"
        (rotateend)="onTouchEnd()">
    </canvas>
  


// WEBPACK FOOTER //
// ./node_modules/@hallysonh/ngx-imageviewer/ngx-imageviewer.d.ts.ImageViewerComponent.html